import React from "react";

interface ModalImovelProps {
  imovel: any;
  onClose: () => void;
}

const ModalImovel: React.FC<ModalImovelProps> = ({ imovel, onClose }) => {
  if (!imovel) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg shadow-xl w-11/12 max-w-3xl relative">
        
        {/* Botão de Fechar */}
        <button
          className="absolute top-3 right-3 text-gray-600 hover:text-red-500 text-3xl"
          onClick={onClose}
        >
          &times;
        </button>

        {/* Imagem do Imóvel */}
        <img
          src={imovel.imagem}
          alt={imovel.titulo}
          className="w-full h-72 object-cover rounded-md shadow-lg"
        />

        {/* Título e Localização */}
        <h2 className="text-3xl font-bold mt-4">{imovel.titulo}</h2>
        <p className="text-gray-500">{imovel.localizacao}</p>

        {/* Detalhes do Imóvel */}
        <div className="mt-4 grid grid-cols-2 gap-4 text-lg">
          <p><strong>🏠 Área:</strong> {imovel.metragem} m²</p>
          <p><strong>🛏️ Quartos:</strong> {imovel.quartos}</p>
          <p><strong>🚿 Banheiros:</strong> {imovel.banheiros}</p>
          <p className="font-bold text-blue-600 text-xl">💰 R$ {imovel.preco}</p>
        </div>

        {/* Botões de Ação */}
        <div className="mt-6 flex flex-col gap-3">
          <a
            href={imovel.url}
            target="_blank"
            rel="noopener noreferrer"
            className="block text-center bg-blue-600 text-white px-6 py-3 rounded-md hover:bg-blue-800 transition font-semibold"
          >
            🔗 Saiba Mais
          </a>
          <a
            href={`https://wa.me/5511940321202?text=Olá, tenho interesse no imóvel ${imovel.titulo}`}
            target="_blank"
            rel="noopener noreferrer"
            className="block text-center bg-green-500 text-white px-6 py-3 rounded-md hover:bg-green-700 transition font-semibold"
          >
            📲 Contatar Agora
          </a>
        </div>
      </div>
    </div>
  );
};

export default ModalImovel;
